<template>
  <div class="modal animated is-active">
    <div class="modal-background"></div>
    <div class="modal-card is-large">
      <header class="modal-card-head">
        <p class="modal-card-title">Payment Orders</p>
      </header>
      <section class="modal-card-body">
        <div class="notification is-danger" v-if="error !== ''">{{ error }}</div>
        <h2 style="margin-top: 0px;"><b>Deadline:</b> {{ payment_group.deadline }}</h2>
        <h2 style="margin-top: 0px;"><b>Currency:</b> {{ payment_group.currency }}</h2>
        <label class="label">Payments</label>
        <table class="table is-bordered is-striped is-narrow">
          <thead>
            <tr>
              <th>Id</th>
              <th>Supplier</th>
              <th>Price</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(payment, index) in payment_group.payments">
              <td>{{payment.id}}</td>
              <td>{{payment.customer}}</td>
              <td>{{payment.value}}</td>
              <td style="text-align: center;">
                <a class="button button-table is-small" @click="excludePayment(index)">
                  <i class="fa fa-trash"></i>
                </a>
              </td>
            </tr>
          </tbody>
          <tfoot>
            <tr>
              <td colspan="2" style="border:none; text-align: right;"><b>TOTAL</b></td>
              <td colspan="1"><b>{{ getTotal().toFixed(2) }} {{ payment_group.currency }}</b></td>
            </tr>
          </tfoot>
        </table>
      </section>
      <footer class="modal-card-foot">
        <div class="control is-grouped is-pulled-right">
          <p class="control is-pulled-right">
            <a class="button is-primary" @click="close(false, 'cancel')">Cancel</a>
          </p>
          <p class="control">
            <a :class="{'button': true, 'is-success': true, 'is-disabled': inProgress, 'is-loading': inProgress}" @click="group()">Group</a>
          </p>
        </div>
      </footer>
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      context: {
        type: Object
      },
      payment_group: {
        type: Object,
        required: true
      },
      callback: {
        type: String
      }
    },
    data () {
      return {
        inProgress: false,
        error: ''
      }
    },
    mounted () {
      this.$nextTick(() => {
        document.body.appendChild(this.$el)
      })
    },
    methods: {
      close (closeOnly, result) {
        if (!closeOnly) {
          this.context[this.callback](result)
        }
        this.$el.remove()
      },
      getTotal () {
        let total = 0
        for (var x = 0; x < this.payment_group.payments.length; x++) {
          total = parseFloat(total) + parseFloat(this.payment_group.payments[x].value)
        }
        return total
      },
      excludePayment (id) {
        this.payment_group.payments.splice(id, 1)
      },
      group () {
        if (window.confirm('Are you sure you want to group payment orders?')) {
          this.inProgress = true
          this.error = ''
          this.context.$http.post(this.context.$store.state.config.apiURL + '/payment/group', this.payment_group).then((response) => {
            this.inProgress = false
            this.close(false, response.body)
          }, (response) => {
            this.inProgress = false
            this.error = response.body
          })
        }
      }
    },
    components: {
    },
    computed: {
      enterClass () {
        return `${this.transition}In`
      },
      leaveClass () {
        return `${this.transition}Out`
      }
    }
  }
</script>
<style lang="scss">

</style>



// WEBPACK FOOTER //
// GroupPayment.vue?463f9ba1